import React, { useLayoutEffect, useRef } from "react";
import { AppBar, Toolbar, Box } from "@mui/material";

export default function NavBar() {
  const appBarRef = useRef(null);

  useLayoutEffect(() => {
    const el = appBarRef.current;
    if (!el || typeof document === 'undefined') return;

    const measure = () => {
      try {
        const h = Math.max(36, Math.round(el.getBoundingClientRect().height || 36));
        document.documentElement.style.setProperty('--app-top', `${h}px`);
        document.documentElement.style.setProperty('--appbar-height', `${h}px`);
      } catch (e) {}
    };

    measure();
    window.addEventListener('resize', measure);
    return () => {
      try { window.removeEventListener('resize', measure); } catch (e) {}
      try { document.documentElement.style.removeProperty('--app-top'); } catch (e) {}
      try { document.documentElement.style.removeProperty('--appbar-height'); } catch (e) {}
    };
  }, []);

  return (
    <AppBar
      ref={appBarRef}
      position="sticky"
      sx={{
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar + 2000,
        height: '36px',
        overflow: 'hidden',
        '& .MuiToolbar-root': {
          minHeight: '36px !important',
          height: '36px !important',
          paddingTop: 0,
          paddingBottom: 0,
        },
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }} />
      </Toolbar>
    </AppBar>
  );
}
